module.exports = __webpack_public_path__ + "img/Pattern-primary.e0b4068d.svg";